import { H4, H5 } from '@/components'
import { useTranslate } from '@ur-solutions/react-hooks'
import type { AbsenceTypeForm } from './absence-type-dialog'

interface Props {
  preset: Exclude<AbsenceTypeForm['preset'], 'SIMPLE' | 'CUSTOM'>
}

export function AbsencePresetExplanation({ preset }: Props) {
  const translations = useTranslate({
    chosen: 'settings.absence.absence-type.preset-explanation.chosen-preset',
    details: 'settings.absence.absence-type.preset-explanation.details',

    presetNames: {
      VACATION_NO: 'settings.absence.absence-type.presets.vacation-no.title',
      SELF_CERTIFICATION_NO:
        'settings.absence.absence-type.presets.self-certification-no.title',
      SICK_CHILD_NO:
        'settings.absence.absence-type.presets.sick-child-no.title',
      FLEXTIME: 'settings.absence.absence-type.presets.flextime.title',
    },
    presetExplanations: {
      VACATION_NO:
        'settings.absence.absence-type.preset-explanation.vacation-no',
      SELF_CERTIFICATION_NO:
        'settings.absence.absence-type.preset-explanation.self-certification-no',
      SICK_CHILD_NO:
        'settings.absence.absence-type.preset-explanation.sick-child-no',
      FLEXTIME: 'settings.absence.absence-type.preset-explanation.flextime',
    },
    extraInfo: {
      SICK_CHILD_NO:
        'settings.absence.absence-type.preset-explanation.sick-child-no-extra',
    },
  })

  return (
    <div>
      <H4>
        <span className="text-stone-500 font-medium">
          {translations.chosen}
        </span>{' '}
        {translations.presetNames[preset]}
      </H4>

      <H5 className="mt-2">{translations.details}</H5>
      <p className="text-sm text-balance">
        {translations.presetExplanations[preset]}
      </p>

      {preset === 'SICK_CHILD_NO' && (
        <p className="text-sm text-balance mt-2">
          {translations.extraInfo.SICK_CHILD_NO}
        </p>
      )}
    </div>
  )
}
